<template>
<Editor api-key="km60m6tmfn9gu740t93gc5b36fzfuplv9t0qkq7g534ikc7v"
v-model="dataModel"
:init="{
    plugins: 'link image lists code fullscreen anchor table',
    menubar: false,
    toolbar: 'undo redo | bold italic underline h2 h3 h4 | table tabledelete | alignleft aligncenter alignright | numlist bullist image | cut copy paste selectall | link unlink anchor | code fullscreen',
    contextmenu: 'cut copy paste selectall',
    statusbar: false,
    height: height,
    progressBar: true,
    toolbar_sticky: true,
    images_file_types: 'jpeg,jpg,png,gif,webp,svg',
    file_picker_callback: my_file_picker_callback,
}" />
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  props: ['product','article','height'],

  components: { Editor },

  data() {
    return {
        endpoint: null,
    };
  },

  mounted() {
    if (this.product) {
      this.endpoint = '/products/content-image';
    } else {
      this.endpoint = '/articles/content-image';
    }
  },

  computed: {
    dataModel: {
      get() {
        return this.product ? this.product.description : this.article.content;
      },
      set(value) {
        if (this.product) {
          this.product.description = value;
        } else {
          this.article.content = value;
        }
      },
    },
  },

  methods: {
    my_file_picker_callback(callback) {

      let originalObject = this;

      var input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");

      input.onchange = function () {
        var file = this.files[0];

        var spinner = document.createElement("i");
        spinner.className = "fas fa-spinner fa-spin fa-4x";
        spinner.style.position = "fixed";
        spinner.style.top = "48%";
        spinner.style.left = "48%";
        spinner.style.zIndex = "9999";
        spinner.style.color = "#007bff";
        document.body.appendChild(spinner);

        // reduce opacity
        var toxDialog = document.querySelector(".tox .tox-dialog");
        if (toxDialog) {
          toxDialog.style.opacity = "0";
        }

        var formData = new FormData();
        formData.append("file", file);

        var token = document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content");

        axios
          .post(originalObject.endpoint, formData, {
            headers: {
              'X-CSRF-TOKEN': token,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            document.body.removeChild(spinner);

            // restore opacity
            if (toxDialog) {
              toxDialog.style.opacity = '1';
            }

            if (response.data.success) {
              callback(response.data.location, { width: '200px', height: null });
            } else {
              console.log(response.data.message);
            }
          })
          .catch((error) => {
            document.body.removeChild(spinner);
            console.log('Upload error:', error);
          });
      };

      input.click();
    },
  },
};
</script> 